module.exports = __webpack_public_path__ + "static/img/login_banner.e5df29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login_banner.png
// module id = abBM
// module chunks = 1